import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ShoppingCartModule } from './shopping-cart/shopping-cart.module';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MainComponent } from './main/main.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { AppRoutingModule } from './app-routing.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { IndProvModalComponent } from './main/ind-prov-modal/ind-prov-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DisplayRequestTableComponent } from './display-request-table/display-request-table.component';
import { DuplicateModalComponent } from './display-request-table/duplicate-modal/duplicate-modal.component';
import { ResignationComponent } from './form/resignation/resignation.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AddRequestModule } from './add-request/add-request.module';
import { RouterModule } from '@angular/router';
import { BlankComponentComponent } from './blank-component/blank-component.component';
import { ConfirmModalComponent } from './main/confirm-modal/confirm-modal.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FileUploadComponent } from './form/file-upload/file-upload.component';
import { FormBaseComponent } from './form/form-base/form-base.component';
import { DeleteModalComponent } from './display-request-table/delete-modal/delete-modal.component';
import { MaintenanceComponent } from './form/maintenance/maintenance.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GroupNewComponent } from './form/group-new/group-new.component';
import { DentPracModalComponent } from './main/dent-prac-modal/dent-prac-modal.component';
import { GroupMaintenanceComponent } from './form/group-maintenance/group-maintenance.component';
import { GroupResignationComponent } from './form/group-resignation/group-resignation.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CapitalPipe } from './form/capital.pipe';
import { NewComponent } from './form/new/new.component';
import { ContactComponent } from './form/contact/contact.component';
import { PhoneDirective } from './form/phone.directive';
import { RecaptchaModule } from 'ng-recaptcha';
import { OptFileUploadComponent } from './form/opt-file-upload/opt-file-upload.component';
import { ErrorBannerComponent } from './errors/error-banner/error-banner.component';
import { DirectAccessGuard } from './guard/direct-access-guard.guard';
import { TextSlicePipe } from './display-request-table/text-slice.pipe';
import { ValidationBannerComponent } from './validation-banner/validation-banner.component';
import { ValidationToString } from './validation-banner/validation-to-string.pipe';
import { ProviderPipePipe } from './display-request-table/provider-pipe.pipe';
import { RequestTypePipe } from './display-request-table/request-type.pipe';
import { AxwayInterceptorService } from './interceptors/axway-interceptor.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    ConfirmComponent,
    IndProvModalComponent,
    DisplayRequestTableComponent,
    DuplicateModalComponent,
    DuplicateModalComponent,
    ResignationComponent,
    BlankComponentComponent,
    ConfirmModalComponent,
    FileUploadComponent,
    FormBaseComponent,
    DeleteModalComponent,
    MaintenanceComponent,
    DentPracModalComponent,
    GroupNewComponent,
    GroupMaintenanceComponent,
    GroupResignationComponent,
    CapitalPipe,
    NewComponent,
    ContactComponent,
    PhoneDirective,
    OptFileUploadComponent,
    ErrorBannerComponent,
    TextSlicePipe,
    ValidationBannerComponent,
    ValidationToString,
    ProviderPipePipe,
    RequestTypePipe
  ],
  imports: [
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    ModalModule.forRoot(),
    FontAwesomeModule,
    ShoppingCartModule,
    AddRequestModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    TooltipModule.forRoot(),
    HttpClientModule,
    RecaptchaModule
  ],
  exports: [],
  providers: [
    DirectAccessGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AxwayInterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
